module.exports = __webpack_public_path__ + "static/media/ch1.3a836497.jpg";